<template>
  <section class="renew-section u-typography-helvetica u-text u-text--m">
    <p class="renew-section__description text-bold u-typography-helvetica u-text u-text--m">
      {{ $t('validationPage.formulaRenewalText') }}
    </p>
    <p class="renew-section__description u-typography-helvetica u-text u-text--m">
      {{ $t('validationPage.formulaRenewalCTAText') }}
    </p>
    <u-button class="renew-section__renew-button" @click="renewTreatment">
      {{ $t('validationPage.renewTreatmentButtonLabel') }}
    </u-button>
  </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { UButton } from 'universkin-shared';

import { getHashedId } from '@/utils/hashids';

import { types } from '@/store/types';

export default {
  name: 'RenewSection',
  components: { UButton },
  props: {
    treatmentPrototypeId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      verificationStatus: ''
    };
  },
  computed: {
    ...mapState({
      doctorSlug: types.state.DOCTOR_SLUG
    })
  },
  methods: {
    ...mapMutations({
      updatePromoCodeData: types.mutations.UPDATE_PROMO_CODE_DATA
    }),
    async renewTreatment() {
      this.updatePromoCodeData(null);

      const hashedId = getHashedId(this.treatmentPrototypeId);
      await this.goToIntermediateRenewPage(hashedId);
    },
    async goToIntermediateRenewPage(hashedPrototypeTreatmentId) {
      await this.$router.push({
        name: 'IntermediateRenewPage',
        params: {
          doctorSlug: this.doctorSlug,
          hashedPrototypeTreatmentId
        },
        query: {
          isPaidOfferLinkUsed: true
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.renew-section {
  &__description:first-child {
    margin-bottom: 8px;
  }

  &__renew-button {
    margin-top: 24px;
    width: 360px;
    max-width: 100%;
  }
}
</style>
